import { render, staticRenderFns } from "./OfferCase.vue?vue&type=template&id=9840febc&scoped=true&"
import script from "./OfferCase.vue?vue&type=script&lang=js&"
export * from "./OfferCase.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=9840febc&prod&scoped=true&lang=css&"
import style1 from "./OfferCase.vue?vue&type=style&index=1&id=9840febc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9840febc",
  null
  
)

export default component.exports